/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCreateModal = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M19 2c1.654 0 3 1.346 3 3a3.006 3.006 0 0 1-2 2.828V16h1.999v6H16l-.001-2h-8.17A3.006 3.006 0 0 1 5 22c-1.654 0-3-1.346-3-3 0-1.304.836-2.416 2-2.829V8H2V2.001h6V4h8.171A3.006 3.006 0 0 1 19 2zm1 16h-2v2h2zM5 18a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM8 8H6v8.172A3.014 3.014 0 0 1 7.829 18h8.17L16 16h2V7.829A3.016 3.016 0 0 1 16.172 6H8zm5 0v3h3v2h-3v3h-2v-3H8v-2h3V8zM6 4H4v2h2zm13 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCreateModal as CreateModal };
